import type { CoreConsentLink } from "@tandemdiabetes/sugarmate-api-react-client"
import { Link } from "@tanstack/react-router"
import type { ReactNode } from "react"

interface Props {
  link: CoreConsentLink;
  className?: string;
  children: ReactNode;
}

export function ConsentLink(props: Props) {
  const {
    link,
    className,
    children,
  } = props

  if (link.contentType === "application/pdf") {
    return (
      <a
        className={className}
        href={link.file}
        target="_blank"
        rel="noreferrer"
      >
        {children}
      </a>
    )
  }

  return (
    <Link
      className={className}
      to="/policy-viewer"
      target="_blank"
      search={{
        title: link.title,
        file: link.file,
      }}
    >
      {children}
    </Link>
  )
}
